import {applyMiddleware, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'
import rootReducer from '../_reducers';
import moment from "moment";
import errorHandler from "./errorMiddleware";

moment.locale('ru')

// export default function initStore(preloadedState) {
//     const middlewares = [errorHandler, thunkMiddleware]
//     const middlewareEnhancer = composeWithDevTools(applyMiddleware(...middlewares))
//
//     // const enhancers = [middlewareEnhancer, monitorReducersEnhancer]
//     const composedEnhancers = compose(middlewareEnhancer)
//
//     return configureStore({
//         rootReducer,
//         preloadedState,
//         composedEnhancers
//     })
// }

const middlewareStore = composeWithDevTools(
    applyMiddleware(
        thunkMiddleware,
        errorHandler
    )
)(createStore);

export const store = middlewareStore(rootReducer, {});
